// File: app/loading.tsx
'use client';

import { useState, useEffect } from 'react';

export default function Loading() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // شبیه‌سازی پیشرفت تا حداکثر ۹۰٪
    const maxFake = 90;
    const interval = setInterval(() => {
      setProgress(p => {
        if (p >= maxFake) return p;
        const inc = Math.random() * 10;
        const next = p + inc;
        return next > maxFake ? maxFake : next;
      });
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 p-6">
      <div className="pointer-events-none absolute -top-28 -left-20 h-80 w-80 rounded-full bg-blue-700/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 -right-16 h-80 w-80 rounded-full bg-cyan-500/20 blur-3xl" />

      <div className="relative flex min-h-screen items-center justify-center">
        <div className="w-full max-w-xl rounded-3xl border border-slate-700/80 bg-slate-900/80 p-8 shadow-2xl backdrop-blur">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-100">
              در حال بارگذاری صفحه
            </h2>
            <div className="h-10 w-10 rounded-full border-2 border-slate-600 border-t-blue-400 animate-spin" />
          </div>

          <div className="relative h-3 w-full overflow-hidden rounded-full bg-slate-800">
            <div
              className="h-3 rounded-full bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 transition-all duration-200 ease-out"
              style={{ width: `${progress}%` }}
            />
            <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 animate-[pulse_1.4s_ease-in-out_infinite] bg-white/20 blur-sm" />
          </div>

          <div className="mt-4 flex items-center justify-between text-sm">
            <span className="text-slate-300">لطفا چند لحظه صبر کنید...</span>
            <span className="font-semibold text-cyan-300">{Math.round(progress)}٪</span>
          </div>
        </div>
      </div>
    </div>
  );
}
